import { useCallback } from 'react'
import { useFfmpeg } from '../../cutter/export/useFfmpeg'
import toast from 'react-hot-toast'
import { getFilenameExtension } from '../../functions/getFilenameExtension'
import { AudioContextFactory } from '../../cutter/contexts/AudioContextFactory'

export function useDecodeArrayBuffer(): (arrayBuffer: ArrayBuffer, filename?: string | null) => Promise<AudioBuffer> {
  const ffmpeg = useFfmpeg()

  return useCallback(
    (arrayBuffer, filename) =>
      AudioContextFactory.getAudioContext()
        .decodeAudioData(arrayBuffer)
        .catch(async () => {
          if (!ffmpeg.isLoaded()) {
            await ffmpeg.load()
          }

          const inputFilename = 'input' + (filename ? '.' + getFilenameExtension(filename) : '')
          const outputFilename = 'output.wav'

          ffmpeg.FS('writeFile', inputFilename, new Uint8Array(arrayBuffer))
          await ffmpeg.run('-i', inputFilename, outputFilename)
          const { buffer } = ffmpeg.FS('readFile', outputFilename)
          ffmpeg.FS('unlink', outputFilename)

          return AudioContextFactory.getAudioContext().decodeAudioData(buffer)
        })
        .catch((reason) => {
          toast.error('The file cannot be decoded as audio')

          return Promise.reject(reason)
        }),
    [ffmpeg],
  )
}
